import { useState, useCallback } from "react";
import { Checkbox, Form, Input, message, Typography } from "antd";
import { UserOutlined, MailOutlined } from "@ant-design/icons";
import Button from "../../components/generic/Button";
import httpClient from "../../api/httpClient";
import PhoneInput from "../../components/shared/PhoneInput";
import { StyledSignUpDiv } from "./styles";
import { ROUTES } from "../../constant/routes";
import { Link, useNavigate } from "react-router-dom";

const Signup = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignup = useCallback(async (values) => {
    setLoading(true);
    try {
      await httpClient.publicPost("customers", {
        ...values,
        ...(values?.mobile_number || {}),
      });

      message.success("Account Created Successful");
      navigate(ROUTES.SIGNIN);
    } catch (error) {
      console.log("🚀 ~ index.jsx:34 ~ Signup~ error:", error);
      //@ts-ignore
      message.error(error?.errorMessage || "Signup failed. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    //@ts-ignore
    <StyledSignUpDiv className="auth-right">
      <div className="signup-div flex-col">
        <div className="right-header">
          <h2>Customer Registration 🔐</h2>
          <p>Sign up to access your dashboard and business tools</p>
        </div>

        <div className="middle-area">
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSignup}
            disabled={loading}
          >
            <Form.Item
              label="First Name"
              name="first_name"
              rules={[{ required: true, message: "Please enter first name" }]}
            >
              <Input prefix={<UserOutlined />} placeholder="First Name" />
            </Form.Item>

            <Form.Item
              name="last_name"
              label="Last Name"
              // rules={[{ required: true, message: "Required" }]}
            >
              <Input prefix={<UserOutlined />} placeholder="Last" />
            </Form.Item>

            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                // { required: true, message: "Please enter your email" },
                { type: "email", message: "Please enter a valid email" },
              ]}
            >
              <Input prefix={<MailOutlined />} placeholder="your@email.com" />
            </Form.Item>

            <PhoneInput split />

            <Form.Item
              name="terms"
              valuePropName="checked"
              rules={[
                {
                  validator(_, value) {
                    if (value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "You must accept the Terms and Conditions to continue",
                      ),
                    );
                  },
                },
              ]}
            >
              <Checkbox>
                I agree to the{" "}
                <Typography.Link
                  target="_blank"
                  className="text-primary"
                  href={"https://kelu.uk/terms"}
                >
                  Terms and Conditions
                </Typography.Link>{" "}
                and{" "}
                <Typography.Link
                  target="_blank"
                  className="text-primary"
                  href={"https://kelu.uk/privacy-policy"}
                >
                  Privacy Policy
                </Typography.Link>
              </Checkbox>
            </Form.Item>
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="submit-button"
                loading={loading}
              >
                Create Account
              </Button>
            </Form.Item>
          </Form>
        </div>
        <div className="text-gray login-link text-center ">
          Already have an account?{" "}
          <Link to={ROUTES.SIGNIN}>
            <Typography.Link className="text-primary">Sign In</Typography.Link>
          </Link>
        </div>
      </div>
    </StyledSignUpDiv>
  );
};

export default Signup;
